import * as login from "./logins";
import * as classes from "./classes";

export const db = { login, classes };
